"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPosWithOffers = void 0;
class GetPosWithOffers {
    constructor(pointsOfSaleService) {
        this.pointsOfSaleService = pointsOfSaleService;
    }
    execute(request) {
        return this.pointsOfSaleService.getPosWithOffers(request);
    }
}
exports.GetPosWithOffers = GetPosWithOffers;
